module.exports = __webpack_public_path__ + "img/evalu-jeu.3de3b53f.png";